import { motion } from 'framer-motion';

export const VerticalBarChart: React.FC<{
  maxValue?: number;
  dataset: {
    id: string;
    label: string;
    data: { value: number; suffix?: string; color: string }[];
  }[];
}> = ({ dataset, maxValue = 100 }) => {
  return (
    <div className="flex w-full space-x-3">
      {dataset.map(({ data, id, label }, index) => (
        <motion.div
          key={id}
          className="relative flex h-[16rem] w-full items-end overflow-hidden rounded-sm bg-neutral-4/20 md:h-[24rem]"
          initial="hidden"
          viewport={{ once: true }}
          whileInView="visible"
        >
          <span className="absolute top-0 z-10 flex w-full items-center justify-center p-4 text-center leading-normal">
            {label}
          </span>
          <span className="absolute bottom-0 z-10 flex w-full items-center justify-center p-4 text-center text-[48px] font-bold leading-none">
            {data[0].value}
            {data[0].suffix || null}
          </span>

          <motion.div
            className="w-full origin-bottom"
            style={{
              height: `${data[0].value * (100 / maxValue)}%`,
              background: data[0].color,
            }}
            transition={{
              ease: 'easeOut',
              duration: 0.4,
              delay: index * 0.1,
            }}
            variants={{
              hidden: { opacity: 0, scaleY: 0 },
              visible: { opacity: 1, scaleY: 1 },
            }}
          />
        </motion.div>
      ))}
    </div>
  );
};
